import { useMemo } from 'react';
import { useFirmEntityUsers } from '../../features/hooks/useFirmEntityUsers/useFirmEntityUsers';
import { Entity } from '@admiin-com/ds-graphql';

interface UseEntitiesProps {
  searchName?: string;
  limit?: number;
}

export const useClients = (props?: UseEntitiesProps) => {
  const results = useFirmEntityUsers({
    searchName: props?.searchName,
    limit: props?.limit,
  });

  const clients: Entity[] = useMemo(() => {
    return results.entityUsers
      .map((entityUser) => entityUser.entity)
      .filter(Boolean) as Entity[];
  }, [results.entityUsers]);
  return {
    clients,
    ...results,
  };
};
